/**
 * The account the bound store belongs to (set by auth.ts `bindTokenScope`, cleared by
 * `unbindTokenScope`), read by onedrive.ts for the transport's remembered approot (`rememberRoot`).
 * Its own module so the many tests that mock `./auth` whole still get a real one.
 */
let boundAccountId: string | null = null

export function setBoundAccountId(accountId: string | null): void {
  boundAccountId = accountId
}

/** `null` before a store is bound (signed out, or deciding which store to open). */
export function getBoundAccountId(): string | null {
  return boundAccountId
}
